import { render, staticRenderFns } from "./PageAppsBanner.vue?vue&type=template&id=35a697b8"
import script from "./PageAppsBanner.vue?vue&type=script&lang=js"
export * from "./PageAppsBanner.vue?vue&type=script&lang=js"
import style0 from "./PageAppsBanner.vue?vue&type=style&index=0&id=35a697b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports